import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import OrganizationFilterCard from "./OrganizationFilter/OrganizationFilterCard";
import OrganizationTable from "./OrganizationTable/OrganizationTable";
import { useDispatch } from "react-redux";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

const tableHeadings = {
  organization_name: "Organization Name",
  organization_number: "Organization Number",
  keeper_folder_id: "Keeper Folder ID",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

interface Props {
  oauthTokenHeader: any;
}

const rows = [
  {
    organization_name: "Optival LTD",
    organization_number: "1,333",
    keeper_folder_id: "dxrsctgyvdhjbwjdnk675764",
    created_on: "Feb. 26, 2024, 6:53 a.m.	",
    created_by: "User Name",
    last_edited: "Feb. 26, 2024, 6:53 a.m.	",
    edited_by: "User Name",
  },
  {
    organization_name: "Optival LTD",
    organization_number: "1,333",
    keeper_folder_id: "dxrsctgyvdhjbwjdnk675764",
    created_on: "Feb. 26, 2024, 6:53 a.m.	",
    created_by: "User Name",
    last_edited: "Feb. 26, 2024, 6:53 a.m.	",
    edited_by: "User Name",
  },
  {
    organization_name: "Optival LTD",
    organization_number: "1,333",
    keeper_folder_id: "dxrsctgyvdhjbwjdnk675764",
    created_on: "Feb. 26, 2024, 6:53 a.m.	",
    created_by: "User Name",
    last_edited: "Feb. 26, 2024, 6:53 a.m.	",
    edited_by: "User Name",
  },
];

const Organization = ({ oauthTokenHeader }: Props) => {
  const [MetaOrganizations, setMetaOrganizations] = useState([]);
  const [selectedMetaOrganizations, setSelectedMetaOrganizations] = useState(
    []
  );
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewOrganizationsPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_organizations"
  );

  useEffect(() => {
    const fetchMetaEntitiesOrganizations = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaOrganizations(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesOrganizations();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewOrganizationsPermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Organizations List</Typography>
            <OrganizationFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <OrganizationTable
              tableHeadings={tableHeadings}
              rows={rows}
              loading={loading}
              MetaOrganizations={MetaOrganizations}
              setMetaOrganizations={setMetaOrganizations}
              oauthTokenHeader={oauthTokenHeader}
              selectedMetaOrganizations={selectedMetaOrganizations}
              setSelectedMetaOrganizations={setSelectedMetaOrganizations}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default Organization;
